var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent, Fragment } from "react";
import { connect } from "@irati/store";
import dealsService from "@irati/deals/services/dealsGraph";
import { hangPromise } from "@irati/utils/promise";
import { H3, H5 } from "@irati/ui/src/Headings";
import { Strong } from "@irati/ui/src/Labels";
import { validatedScreen } from "@irati/utils/validation";
import { getThumbnailImage } from "@irati/utils/images/getImageSize/getImageSize";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import ImageDivider from "./shared/ImageDivider";
import ImportantInfo from "./shared/ImportantInfo";
import { SuccessWrapper, ContentWrapper, StyledLabel2, ThumbnailsWrapper, ThumbnailImage, PerksGOIcon } from "./styled/Success";
import SuccessButton from "./SuccessButton";
var SuccessLinkedCard = /** @class */ (function (_super) {
    __extends(SuccessLinkedCard, _super);
    function SuccessLinkedCard(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.setState({ load: _this.getDeals() });
        };
        _this.getDeals = function () {
            return dealsService.perksGoPromotionalDeals().then(function (deals) {
                _this.setState({ deals: deals });
            });
        };
        _this.state = {
            deals: [],
            load: hangPromise()
        };
        return _this;
    }
    SuccessLinkedCard.prototype.render = function () {
        var _a = this.props, lastFour = _a.lastFour, isMobile = _a.isMobile, isInDeal = _a.isInDeal, onComplete = _a.onComplete;
        var _b = this.state, load = _b.load, deals = _b.deals;
        return (React.createElement(SuccessWrapper, null,
            React.createElement(ContentWrapper, null,
                React.createElement(H3, { bold: true, margin: "0 0 20px 0" },
                    React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.header" })),
                React.createElement(ImportantInfo, null,
                    React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.importantInfo", values: { number: React.createElement(Strong, null,
                                "**** **** **** ",
                                lastFour) } })),
                React.createElement(Fragment, null,
                    React.createElement(H5, null,
                        React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.body.title" })),
                    React.createElement(Loading, { load: load },
                        React.createElement(ThumbnailsWrapper, null, deals.slice(0, isMobile ? 3 : 4).map(function (deal) {
                            return React.createElement(ThumbnailImage, { key: deal.uuid, src: getThumbnailImage(deal.thumbnailImage) });
                        })))),
                React.createElement(ImageDivider, { imageWidth: 80, imageHeight: 50, padding: 25 },
                    React.createElement(PerksGOIcon, { icon: "perksGO", size: 80 })),
                React.createElement(StyledLabel2, null,
                    React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.body.desc" }))),
            React.createElement(SuccessButton, { isInDeal: isInDeal, onComplete: onComplete })));
    };
    SuccessLinkedCard.defaultProps = {
        isInDeal: false
    };
    return SuccessLinkedCard;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium
    };
};
export default injectIntl(connect(mapStateToProps)(validatedScreen(SuccessLinkedCard, "SuccessLinkedCard")));
